const ClientSummaryMetrics = ({ metrics }) => {
  if (!metrics?.length) {
    return null;
  }

  return (
    <section className="panel-card cv-studio-metrics-grid" aria-label="Summary metrics">
      {metrics.map((metric) => (
        <div key={metric.label} className="cv-studio-metric">
          <span>{metric.label}</span>
          <strong>{metric.value}</strong>
        </div>
      ))}
    </section>
  );
};

export default ClientSummaryMetrics;
